export const skipAnimations = () : boolean => {
  if (window.Cypress) {
    return true;
  }
  
  return false;
};